import * as React from 'react';

import {PopoverContext, usePopover} from './usePopover';
import {RegisterPopoverWithOverlay} from '@packages/systems/ui/overlay';

import type {PopoverProps} from './usePopover';

/**
 * @component
 */
export const Popover = ({
  children,
  containerPadding,
  defaultIsOpen,
  horizontalOffset,
  isOpen,
  limitShiftOptions,
  maskProps,
  minHeight,
  maxHeight,
  maxWidth: maxWidthProp,
  minWidth: minWidthProp,
  width,
  onOpenChange: onOpenChangeProp,
  placement,
  returnFocus = true,
  shouldEscapeViewport,
  shouldHideOnClickOutside,
  shouldPreventBodyScroll,
  shouldResizeContentToMatchTrigger,
  shouldShowMask,
  shouldTrapFocus,
  verticalOffset,
  anchorRef,
}: PopoverProps) => {
  let maxWidth = maxWidthProp;
  let minWidth = minWidthProp;

  if (width) {
    maxWidth = width;
    minWidth = width;
  }

  const arrowRef = React.useRef(null);
  const context = usePopover({
    anchorRef,
    arrowRef,
    containerPadding,
    defaultIsOpen,
    horizontalOffset,
    isOpen,
    limitShiftOptions,
    maxWidth,
    minWidth,
    onOpenChange: onOpenChangeProp,
    placement,
    shouldEscapeViewport,
    shouldHideOnClickOutside,
    shouldPreventBodyScroll,
    shouldResizeContentToMatchTrigger,
    verticalOffset,
  });

  return (
    <RegisterPopoverWithOverlay>
      <PopoverContext.Provider
        value={{
          ...context,
          arrowRef,
          maskProps,
          maxHeight,
          minHeight,
          returnFocus,
          shouldShowMask,
          shouldTrapFocus,
        }}
      >
        {children}
      </PopoverContext.Provider>
    </RegisterPopoverWithOverlay>
  );
};
